import { cssTransition } from '../utils';
const Slide = cssTransition({
    appendPosition: true,
});

export { Slide };
